<template>
    <div>
        <div class="table-wrapper on-991" v-if="$i18n.locale=='en'">
            <div>
                <table>
                    <thead>
                        <tr class="dark-gray">
                            <td class="text-right text-white font-weight-bold" colspan="2">Index</td>
                            <td class="b-left text-right text-white font-weight-bold">Conversion factor</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>31 December 2020</td>
                            <td class="text-right">18,863</td>
                            <td class="text-right">1.00</td>
                        </tr>
                        <tr>
                            <td>31 December 2019</td>
                            <td class="text-right">10,657</td>
                            <td class="text-right">1.77</td>
                        </tr>
                        <tr>
                            <td>31 December 2018</td>
                            <td class="text-right">6,306</td>
                            <td class="text-right">2.99</td>
                        </tr>
                        <tr>
                            <td>31 December 2017</td>
                            <td class="text-right">4,502</td>
                            <td class="text-right">4.19</td>
                        </tr>
                        <tr>
                            <td>31 December 2016</td>
                            <td class="text-right">2,068</td>
                            <td class="text-right">9.12</td>
                        </tr>
                        <tr>
                            <td>31 December 2015</td>
                            <td class="text-right">357</td>
                            <td class="text-right">52.83</td>
                        </tr>
                        <tr>
                            <td>31 December 2014</td>
                            <td class="text-right">170</td>
                            <td class="text-right">110.95</td>
                        </tr>
                        <tr>
                            <td>31 December 2013</td>
                            <td class="text-right">155</td>
                            <td class="text-right">121.70</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Arabic -->

        <div class="table-wrapper on-991" v-if="$i18n.locale=='ar'">
            <div>
                <table>
                    <thead>
                        <tr class="dark-gray">
                            <td class="text-right text-white font-weight-bold" colspan="2">المؤشر</td>
                            <td class="b-left text-right text-white font-weight-bold">عامل التغير</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>31 ديسمبر 2020</td>
                            <td class="text-right">18,863</td>
                            <td class="text-right">1.00</td>
                        </tr>
                        <tr>
                            <td>31 ديسمبر 2019</td>
                            <td class="text-right">10,657</td>
                            <td class="text-right">1.77</td>
                        </tr>
                        <tr>
                            <td>31 ديسمبر 2018</td>
                            <td class="text-right">6,306</td>
                            <td class="text-right">2.99</td>
                        </tr>
                        <tr>
                            <td>31 ديسمبر 2017</td>
                            <td class="text-right">4,502</td>
                            <td class="text-right">4.19</td>
                        </tr>
                        <tr>
                            <td>31 ديسمبر 2016</td>
                            <td class="text-right">2,068</td>
                            <td class="text-right">9.12</td>
                        </tr>
                        <tr>
                            <td>31 ديسمبر 2015</td>
                            <td class="text-right">357</td>
                            <td class="text-right">52.83</td>
                        </tr>
                        <tr>
                            <td>31 ديسمبر 2014</td>
                            <td class="text-right">170</td>
                            <td class="text-right">110.95</td>
                        </tr>
                        <tr>
                            <td>31 ديسمبر 2013</td>
                            <td class="text-right">155</td>
                            <td class="text-right">121.70</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>